export default {
  ByCounts: 'splitByCounts',
  ByItems: 'splitByItems',
}
